import {
  buildFabricAuthHeaders,
  createApiAxios,
  getFabricAuthTokens,
  getFabricEndpoint,
} from '@/utilities/axios/api-axios';
import { getBaseURL, getDomain } from '@/utilities/getters/gameContextGetters';

import { FABRIC_HEADERS } from '@/utilities/constants/metadata';
import config from '@/config';

import { useStore } from '@/store/useStore';

const customerDataRequest = async (
  endpointName: string,
  queryParams: {
    isSWJGame?: boolean;
    isDYBGame?: boolean;
    isOptedIn?: boolean;
    jackpotId?: string;
  } = {},
) => {
  const endpoint = getFabricEndpoint('customerData', endpointName);
  const baseURL = getBaseURL();

  const { region, brand } = useStore.getState().runtime;
  const tokens = await getFabricAuthTokens('FETCH_CUSTOMER_FEATURES');

  const instance = createApiAxios({}, true);

  const requestData = {
    baseURL,
    params: {
      product: config.geoComply.product,
      ...queryParams,
    },
    headers: {
      ...buildFabricAuthHeaders(tokens),
      [FABRIC_HEADERS.X_DOMAIN]: getDomain(),
      [FABRIC_HEADERS.X_REGION_CODE]: region,
      [FABRIC_HEADERS.X_BRAND]: brand,
    },
  };

  const response = await instance.get(endpoint, requestData);
  return response?.data;
};

export default customerDataRequest;
